import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Campo de texto del formulario de recepción de vehículo (presentacional puro).
export const Field = ({ label, value, onChange, testid }) => (
  <div className="space-y-1.5">
    <Label className="text-[10px] tracking-[0.1em] uppercase font-bold text-white/60">{label}</Label>
    <Input value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="h-11 rounded-none bg-white/5 border-white/20 text-white focus-visible:ring-2 focus-visible:ring-[#FFCC00]" />
  </div>
);

export default Field;
